<template>
  <div class="editEmployeeAvailibilityVue">
   <!-- HUGE COMMENT -->
        <!-- Please add autocomplete='off' to all input fields or at form level -->
        
    <div class="c-responsive-fixwidth">
        <div class="clearfix o-skillset-area">
            <div class="employer-info">
                <div class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-9">
                              <div class="c-common-space c-common-box-shadow c-radius3">
                                  <div class="c-user-tab-content clearfix o-skillset-area">
                                      <h2 class="h2">
                                        {{ $t('recurring_conflicts') }}: 
                                      </h2>
                                      <p class="h5-v2">
                                            <strong style="text-transform: capitalize;"> {{ $t('note') }}: </strong>
                                            {{ $t('recurring_unavailability_note') }}
                                        </p>
                                      <!-- <p class="h5-v2 h5-v2-overwrite"><span class="red-mark">Note :</span>Enter the start and end times of unavailable periods separated by a hyphen <strong class="red-mark">(ex: 13:10-18:30)</strong>. For multiple periods within a single day, separate periods with a comma <strong class="red-mark">(ex: 10:20-18:30,20:30-22:30)</strong></p> -->
                                      <!-- <div class="row">
                                          <div class="col-sm-4 table-td-border-right">
                                              <div class="form-group ">
                                                  <label class="common-label-text">Sunday</label>
                                                  <input type="text" class="form-control" @change="onUpdateInputField" v-model="weeklyVacation.sun" placeholder="Enter Unavailability">
                                              </div>
                                          </div>
                                          <div class="col-sm-4 table-td-border-right">
                                              <div class="form-group ">
                                                  <label class="common-label-text">Monday</label>
                                                  <input type="text" v-model="weeklyVacation.mon" @change="onUpdateInputField" class="form-control" placeholder="Enter Unavailability">
                                              </div>
                                          </div>
                                          <div class="col-sm-4">
                                              <div class="form-group ">
                                                  <label class="common-label-text">Tuesday</label>
                                                  <input type="text" v-model="weeklyVacation.tue" @change="onUpdateInputField" class="form-control" placeholder="Enter Unavailability">
                                              </div>
                                          </div>
                                          <div class="col-sm-4 table-td-border-right">
                                              <div class="form-group ">
                                                  <label class="common-label-text">Wednesday</label>
                                                  <input type="text" v-model="weeklyVacation.wed" @change="onUpdateInputField" class="form-control" placeholder="Enter Unavailability">
                                              </div>
                                          </div>
                                          <div class="col-sm-4 table-td-border-right">
                                              <div class="form-group ">
                                                  <label class="common-label-text">Thursday</label>
                                                  <input type="text" v-model="weeklyVacation.thu" @change="onUpdateInputField" class="form-control" placeholder="Enter Unavailability">
                                              </div>
                                          </div>
                                          <div class="col-sm-4">
                                              <div class="form-group ">
                                                  <label class="common-label-text">Friday</label>
                                                  <input type="text" v-model="weeklyVacation.fri" @change="onUpdateInputField" class="form-control" placeholder="Enter Unavailability">
                                              </div>
                                          </div>
                                          <div class="col-sm-4 table-td-border-right">
                                              <div class="form-group ">
                                                  <label class="common-label-text">Saturday</label>
                                                  <input type="text" v-model="weeklyVacation.sat" @change="onUpdateInputField" class="form-control" placeholder="Enter Unavailability">
                                              </div>
                                          </div>
                                      </div> -->
                                      <div class="col-md-12">
                                          <ul class="c-skillset c-skillset--avail">
                                              <li class="table-td-border-right">
                                                  <h6 class="h6">{{ $t('sunday') }}</h6>
                                                  <div v-if="Object.keys(getAvailibityList['1']).length === 0" class="o-avail-tag">
                                                      <p class="h5-v2">{{ $t('available') }}</p>
                                                  </div>
                                                  <div v-else v-for="(getAvail, index) in getAvailibityList['1']" :key="index" class="o-ocup-tag">
                                                      <p class="h5-v2">
                                                        {{ $t('occupied_from') }} {{getAvail[0]}} - {{getAvail[1]}}
                                                        <a @click="deleteRow(index, 1)"><i class="fa fa-times unavaliablility-delete-btn" aria-hidden="true"></i></a>
                                                      </p>

                                                  </div>
                                              </li>
                                              <li class="table-td-border-right">
                                                  <h6 class="h6">{{ $t('monday') }}</h6>
                                                  <div v-if="Object.keys(getAvailibityList['2']).length === 0" class="o-avail-tag">
                                                      <p class="h5-v2">{{ $t('available') }}</p>
                                                  </div>
                                                  <div v-else v-for="(getAvail, index) in getAvailibityList['2']" :key="index" class="o-ocup-tag">
                                                      <p class="h5-v2">{{ $t('occupied_from') }} {{getAvail[0]}} - {{getAvail[1]}}
                                                        <a @click="deleteRow(index, 2)"><i class="fa fa-times unavaliablility-delete-btn" aria-hidden="true"></i></a>
                                                      </p>
                                                  </div>
                                              </li>
                                              <li class="">
                                                  <h6 class="h6">{{ $t('tuesday') }}</h6>
                                                  <div v-if="Object.keys(getAvailibityList['3']).length === 0" class="o-avail-tag">
                                                      <p class="h5-v2">{{ $t('available') }}</p>
                                                  </div>
                                                  <div v-else v-for="(getAvail, index) in getAvailibityList['3']" :key="index" class="o-ocup-tag">
                                                      <p class="h5-v2">{{ $t('occupied_from') }} {{getAvail[0]}} - {{getAvail[1]}}
                                                        <a @click="deleteRow(index, 3)"><i class="fa fa-times unavaliablility-delete-btn" aria-hidden="true"></i></a>
                                                      </p>
                                                  </div>
                                              </li>
                                              <li class="table-td-border-right">
                                                  <h6 class="h6">{{ $t('wednesday') }}</h6>
                                                  <div v-if="Object.keys(getAvailibityList['4']).length === 0" class="o-avail-tag">
                                                      <p class="h5-v2">{{ $t('available') }}</p>
                                                  </div>
                                                  <div v-else v-for="(getAvail, index) in getAvailibityList['4']" :key="index" class="o-ocup-tag">
                                                      <p class="h5-v2">{{ $t('occupied_from') }} {{getAvail[0]}} - {{getAvail[1]}}
                                                        <a @click="deleteRow(index, 4)"><i class="fa fa-times unavaliablility-delete-btn" aria-hidden="true"></i></a>
                                                      </p>
                                                  </div>
                                              </li>
                                              <li class="table-td-border-right">
                                                  <h6 class="h6">{{ $t('thursday') }}</h6>
                                                   <div v-if="Object.keys(getAvailibityList['5']).length === 0" class="o-avail-tag">
                                                      <p class="h5-v2">{{ $t('available') }}</p>
                                                  </div>
                                                  <div v-else v-for="(getAvail, index) in getAvailibityList['5']" :key="index" class="o-ocup-tag">
                                                      <p class="h5-v2">{{ $t('occupied_from') }} {{getAvail[0]}} - {{getAvail[1]}}
                                                        <a @click="deleteRow(index, 5)"><i class="fa fa-times unavaliablility-delete-btn" aria-hidden="true"></i></a>
                                                      </p>
                                                  </div>
                                              </li>
                                              
                                              <li class="">
                                                  <h6 class="h6">{{ $t('friday') }}</h6>
                                                  <div v-if="Object.keys(getAvailibityList['6']).length === 0" class="o-avail-tag">
                                                      <p class="h5-v2">{{ $t('available') }}</p>
                                                  </div>
                                                  <div v-else v-for="(getAvail, index) in getAvailibityList['6']" :key="index" class="o-ocup-tag">
                                                      <p class="h5-v2">{{ $t('occupied_from') }} {{getAvail[0]}} - {{getAvail[1]}}
                                                        <a @click="deleteRow(index, 6)"><i class="fa fa-times unavaliablility-delete-btn" aria-hidden="true"></i></a>
                                                      </p>
                                                  </div>
                                              </li>
                                              
                                              <li class="table-td-border-right">
                                                  <h6 class="h6">{{ $t('saturday') }}</h6>
                                                  <div v-if="Object.keys(getAvailibityList['7']).length === 0" class="o-avail-tag">
                                                      <p class="h5-v2">{{ $t('available') }}</p>
                                                  </div>
                                                  <div v-else v-for="(getAvail, index) in getAvailibityList['7']" :key="index" class="o-ocup-tag">
                                                      <p class="h5-v2">{{ $t('occupied_from') }} {{getAvail[0]}} - {{getAvail[1]}}
                                                        <a @click="deleteRow(index, 7)"><i class="fa fa-times unavaliablility-delete-btn" aria-hidden="true"></i></a>
                                                      </p>
                                                  </div>
                                              </li>    
                                          </ul>                        
                                      </div>
                                  </div>
                              </div>
                            </div>
                            <div class="col-sm-3 o-no-padding">
                                <div class="c-common-space c-common-box-shadow c-radius3">
                                  <div class="c-user-tab-content clearfix o-skillset-area" style="min-height: 430px;">
                                      <h2 class="h2">{{ $t('add_recurring_unavailability') }}:</h2>
                                          <div class="row">
                                              <div class="col-sm-12">
                                                  <div class="form-group ">
                                                      <label class="common-label-text">{{ $t('start_time') }}</label>
                                                      <date-picker 
                                                       name="start-time" 
                                                       placeholder="HH:MM AM" 
                                                       v-model="addUnavailibity.start" 
                                                       :config="config"
                                                       >
                                                       </date-picker>
                                                  </div>
                                              </div>
                                              <div class="col-sm-12">
                                                  <div class="form-group ">
                                                      <label class="common-label-text">{{ $t('end_time') }}</label>
                                                      <date-picker 
                                                       name="start-time1" 
                                                       placeholder="HH:MM AM" 
                                                       v-model="addUnavailibity.end" 
                                                       :config="config"
                                                       >
                                                       </date-picker>
                                                  </div>
                                              </div>
                                              <div class="col-sm-12">
                                                  <div class="form-group ">
                                                      <label class="common-label-text">{{ $t('select_day') }}</label>
                                                      <!-- <input type="text" v-model="weeklyVacation.mon" @change="onUpdateInputField" class="form-control" placeholder="Enter Unavailability"> -->
                                                      <select v-model="addUnavailibity.day" class="form-control">
                                                        <option value="0">{{ $t('select_day') }}</option>
                                                        <option value="1">{{ $t('sunday') }}</option>
                                                        <option value="2">{{ $t('monday') }}</option>
                                                        <option value="3">{{ $t('tuesday') }}</option>
                                                        <option value="4">{{ $t('wednesday') }}</option>
                                                        <option value="5">{{ $t('thursday') }}</option>
                                                        <option value="6">{{ $t('friday') }}</option>
                                                        <option value="7">{{ $t('saturday') }}</option>
                                                      </select>
                                                  </div>
                                              </div>
                                              <div class="col-sm-12">
                                                  <div class="o-employe-view">
                                                     <!-- <a href="javascript: void(0)" @click="addUnavailability()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-green mr-10"><i class="fa fa-plus" aria-hidden="true"></i> Add Unavailability</a> -->

                                                    <a href="javascript: void(0)" @click="saveUnavailability()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save"></i>{{ $t('save') }}</a>

                                                </div>
                                              </div>
                                          </div>
                                  </div>
                                </div>
                            </div>
                            <div class="col-sm-12 o-no-padding">
                                <div class="col-sm-6 o-right-padding-only">
                                    <div class="c-common-space c-common-box-shadow c-radius3">
                                        <div class="c-user-tab-content clearfix o-skillset-area js-employee-boxHeight c-user-vacation-mam-height">
                                            <div class="col-md-12">
                                                <h2 class="h2">{{ $t('running') }}:</h2>
                                                <div v-for="(vacation,index) in running" :key="index" class="o-running-strip">
                                                  <div class="u-pad-all-15 c-radius3 u-alert-bg">
                                                    <strong>{{ $t('label') }}: </strong> {{vacation.label}}
                                                  </div>
                                                  <div class="u-pad-all-15 c-radius3 o-vacation-label">
                                                      {{ $t('on_leave_from') }} <strong>{{getDateFormat(vacation.start)}}</strong> {{ $t('to') }} <strong>{{getDateFormat(vacation.end)}}</strong>.
                                                      <span v-if="userType=='client-admin' || userType=='power-user'" class="o-float-right o-upcome-setting">
                                                        <a href="javascript: void(0)" @click="editVacation(vacation.id)"><i class="fa fa-pencil"></i></a>
                                                        <a href="javascript: void(0)" @click="deleteVacation(vacation.id)"><i class="fa fa-trash"></i></a>
                                                      </span>
                                                  </div>
                                                </div>
                                                <div v-if="running.length == 0" class="u-pad-all-15 c-radius3 u-alert-bg o-running-strip">
                                                    {{ $t('currently_available') }}
                                                </div> 
                                            </div>
                                            <div class="col-md-12">
                                              <h2 class="h2">{{ $t('upcoming') }}:</h2>
                                              <ul class="o-employee-upcoming o-running-strip">
                                                <li v-for="(vacation,index) in upcoming" :key="index">
                                                  <div class="u-pad-all-15 c-radius3 o-upcome-list">
                                                    <strong>{{ $t('label') }}: </strong> {{vacation.label}}
                                                  </div>
                                                  <div class="u-pad-all-15 c-radius3 o-upcome-list o-vacation-label"> {{ $t('on_leave_from') }} 
                                                    <strong>{{getDateFormat(vacation.start)}}</strong> {{ $t('to') }} 
                                                    <strong>{{getDateFormat(vacation.end)}}</strong>
                                                    <span class="o-float-right o-upcome-setting">
                                                      <a href="javascript: void(0)" @click="editVacation(vacation.id)"><i class="fa fa-pencil"></i></a>
                                                      <a href="javascript: void(0)" @click="deleteVacation(vacation.id)"><i class="fa fa-trash"></i></a>
                                                    </span>
                                                  </div>
                                                </li>
                                                <li v-if="upcoming.length == 0">
                                                  <div class="u-pad-all-15 c-radius3 o-upcome-list">
                                                    {{ $t('no_upcoming_leave_found') }}
                                                  </div>
                                                </li>     
                                              </ul>
                                              <div class="o-employe-view">
                                                <!-- <a @click="addVacationHistory()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i> View History</a> -->
                                                
                                                <a href="javascript: void(0)" @click="gotoVacationLog()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-eye" aria-hidden="true"></i>{{ $t('vacation_log') }}</a>

                                                <a href="https://callsteward.freshdesk.com/a/solutions/articles/24000057026" target="_blank" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-green">Policy</a>
                                              </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 o-left-padding-only">
                                    <div class="c-common-space c-common-box-shadow c-radius3 o-overflow-show">
                                        <div class="c-user-tab-content clearfix o-skillset-area js-employee-boxAppend c-user-vacation-mam-height">  
                                            <div class="col-md-12 o-no-padding">
                                                <h2 class="h2">Request time off:</h2>
                                            </div>
                                            <div class="col-sm-12 o-no-padding o-running-strip">
                                               <div class="row">
                                                           
                                                <div class="col-sm-6">
                                                    <div class="form-group o-margin-bottom5">
                                                        <label class="employee-label-text">{{ $t('start_date') }}:</label>
                                                        <label class="employee-label-input">

                                                           <el-date-picker 
                                                           type="date" 
                                                           class="custom_date"
                                                           :placeholder="getDatePlaceholder()"  
                                                           style="width: 100%;" 
                                                           v-validate="{ required: true}" 
                                                           name="startDate" 
                                                           v-model="empAvail.startDate"
                                                           :format="getDisplayFormat()"
                                                            value-format="yyyy-MM-dd"
                                                            @change="setEndDate()"
                                                           >    
                                                           </el-date-picker>
                                                           <span v-show="errors.has('startDate') && this.validation_err!=0" class="err-msg">{{ errors.first('startDate') }}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group o-margin-bottom5">
                                                        <label class="employee-label-text">{{ $t('start_time') }}:</label>
                                                        <label class="employee-label-input">

                                                       <date-picker 
                                                       name="startTime" 
                                                       placeholder="HH:MM AM" 
                                                       v-validate="{required: true}" 
                                                       v-model="empAvail.startTime" 
                                                       :config="config"
                                                       >
                                                       </date-picker>
                                                       <span v-show="errors.has('startTime') && this.validation_err!=0" class="err-msg">{{ errors.first('startTime') }}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                </div>
                                               <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="form-group o-margin-bottom5">
                                                            <label class="employee-label-text">{{ $t('end_date') }}:</label>
                                                            <label class="employee-label-input">

                                                        <el-date-picker 
                                                        type="date" 
                                                        class="custom_date"
                                                        :placeholder="getDatePlaceholder()"  
                                                        style="width: 100%;" 
                                                        v-validate="{ required: true}" 
                                                        name="endDate" 
                                                        :picker-options="getPickerOption(empAvail.startDate)"
                                                        v-model="empAvail.endDate"
                                                        :format="getDisplayFormat()"
                                                        value-format="yyyy-MM-dd"
                                                        >    
                                                        </el-date-picker>
                                                        <span v-show="errors.has('endDate') && this.validation_err!=0" class="err-msg">{{ errors.first('endDate') }}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="form-group o-margin-bottom5">
                                                            <label class="employee-label-text">{{ $t('end_time') }}:</label>
                                                            <label class="employee-label-input">

                                                        <date-picker 
                                                        name="endTime" 
                                                        placeholder="HH:MM AM" 
                                                        v-validate="{required: true}" 
                                                        v-model="empAvail.endTime" 
                                                        :config="config"
                                                        >
                                                        </date-picker>
                                                        <span v-show="errors.has('endTime') && this.validation_err!=0" class="err-msg">{{ errors.first('endTime') }}</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row"> 
                                                    <div class="col-sm-12">
                                                        <div class="form-group">
                                                            <label class="employee-label-text">{{ $t('comments') }}:</label>
                                                            <textarea autocomplete="off" v-model="empAvail.label" name="label" class="form-control" rows="4" :placeholder="$t('enter_your_comments')"></textarea>
                                                            <span v-show="errors.has('label') && this.validation_err!=0" class="err-msg">{{ errors.first('label') }}</span>
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 o-no-padding">
                                                <div class="o-employe-view">
                                                    <!-- <a href="javascript: void(0)" @click="addVacation()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-green mr-10"><i class="fa fa-plus" aria-hidden="true"></i> Add Vacation</a> -->

                                                    <a href="javascript: void(0)" @click="saveVacation()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save"></i>{{ $t('save') }}</a>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
      
    <modal name="vacation-details"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
    <div  tabindex="-1" role="dialog">
           <div  role="document">
               <div class="modal-content o-common-modal-content">
                   <div class="modal-header text-center">
                       <button @click="closeVacationDetails()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                       <h1 class="modal-title">{{ $t('vacation') }}</h1>
                   </div>
                   <div class="modal-body c-common-box-shadow o-modal-body">
                        <div class="row">
                            <div class="col-sm-12 o-no-padding o-running-strip">
                               <div class="row">
                                    <h1 class="h2 o-decline-text">{{vacation_conflict_status}} - <strong>{{getDate(assignVacation.start)}} {{getTime(assignVacation.start)}}</strong> {{ $t('to') }}<strong>{{getDate(assignVacation.end)}} {{getTime(assignVacation.end)}}</strong></h1>

                                </div>

                            </div>
                        </div>
                    </div>                        

                    <div class="modal-footer text-center">
                       
                    </div>
               
               </div>
               <!-- /.modal-content -->
           </div>
           <!-- /.modal-dialog -->
       </div>
    </modal>
      
    <modal name="vacation-edit"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
      <div tabindex="-1" role="dialog">
             <div role="document">
                 <div class="modal-content o-common-modal-content">
                     <div class="modal-header text-center">
                         <button @click="closeVacationEdit()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                         <h1 class="modal-title">{{ $t('edit_vacation') }}</h1>
                     </div>
                     <div class="modal-body c-common-box-shadow o-modal-body o-vacation-edit-modal">
                          <div class="row">
                              <div class="col-sm-12 o-running-strip">
                                  <div class="row">

                                  <div class="col-sm-6">
                                  <div class="form-group ">
                                      <label class="employee-label-text">{{ $t('start_date') }}:</label>
                                      <label class="employee-label-input">
                                         <el-date-picker 
                                         type="date" 
                                         class="custom_date"
                                         :placeholder="getDatePlaceholder()"  
                                         style="width: 100%;" 
                                         v-validate="" 
                                         name="updatestartDate" 
                                         v-model="empAvailupdate.startDate"
                                         :format="getDisplayFormat()"
                                         value-format="yyyy-MM-dd"
                                         >    
                                         </el-date-picker>
                                      </label>
                                  </div>
                                  </div>
                                  <div class="col-sm-6">
                                  <div class="form-group ">
                                      <label class="employee-label-text">{{ $t('start_time') }}:</label>
                                      <label class="employee-label-input">
                                     <date-picker 
                                     name="updatestartTime" 
                                     v-validate="" 
                                     placeholder="HH:MM AM" 
                                     v-model="empAvailupdate.startTime" 
                                     :config="config"
                                     verticalModes="top"
                                     >
                                     </date-picker>
                                      </label>
                                  </div>
                                  </div>
                                  </div>
                                  <div class="row">
                                  <div class="col-sm-6">
                                      <div class="form-group ">
                                          <label class="employee-label-text">{{ $t('end_date') }}:</label>
                                          <label class="employee-label-input">
                                         <el-date-picker 
                                         type="date" 
                                         class="custom_date"
                                         :placeholder="getDatePlaceholder()"  
                                         style="width: 100%;" 
                                         v-validate="" 
                                         name="updateendDate" 
                                         :picker-options="getPickerOption(empAvailupdate.startDate)"
                                         v-model="empAvailupdate.endDate"
                                         :format="getDisplayFormat()"
                                         value-format="yyyy-MM-dd"
                                         >    
                                         </el-date-picker>
                                          </label>
                                      </div>
                                  </div>
                                  <div class="col-sm-6">
                                      <div class="form-group ">
                                          <label class="employee-label-text">{{ $t('end_time') }}:</label>
                                          <label class="employee-label-input">
                                         <date-picker 
                                         name="updateendTime" 
                                         v-validate=""
                                         placeholder="HH:MM AM" 
                                         v-model="empAvailupdate.endTime" 
                                         :config="config"
                                         >
                                         </date-picker>
                                          </label>
                                      </div>
                                  </div>
                                  </div>
                                </div>
                          </div>
                          <div class="row">
                              <div class="col-sm-12 o-running-strip">
                                <div>
                                  <div class="col-sm-2">
                                    <div class="form-group ">
                                        <label class="employee-label-text">{{ $t('label') }}:</label>
                                    </div>
                                  </div>
                                  <div class="col-sm-10">
                                    <div class="form-group ">
                                        <!-- <label class="employee-label-input"> -->
                                           <textarea autocomplete="off" v-model="empAvailupdate.label" name="label" class="form-control" rows="2" :placeholder="$t('text_area')"></textarea>
                                           <span v-show="errors.has('label') && this.validation_err!=0" class="err-msg">{{ errors.first('label') }}</span>
                                        <!-- </label> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </div>
                      </div>                        

                      <div class="modal-footer text-center">
                         <ul class="o-filter-area">
                              <li>
                                  <a href="javascript: void(0)" @click="closeVacationEdit()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> {{ $t('cancel') }}</a>
                              </li>
                              <li>
                                  <a href="javascript: void(0)" @click="vacationUpdate()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> {{ $t('save') }}</a>
                              </li>
                          </ul>
                      </div>
                 
                 </div>
                 <!-- /.modal-content -->
             </div>
             <!-- /.modal-dialog -->
         </div>
    </modal>
      
    <modal name="vacation-history"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
      <div  tabindex="-1" role="dialog">
             <div  role="document">
                 <div class="modal-content o-common-modal-content">
                     <div class="modal-header text-center">
                         <button @click="closeVacationHistory()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                         <h1 class="modal-title">{{ $t('vacation_history') }}</h1>
                     </div>
                     <div class="modal-body c-common-box-shadow o-modal-body o-no-padding-modal">
                             <div v-for="(vacation,index) in vacationHistory" :key="index" class="o-running-strip o-vacation-history">
                                  {{ $t('took_leave_from') }} <strong>{{getDateFormat(vacation.start)}}</strong> {{ $t('to') }}<strong>{{getDateFormat(vacation.end)}}</strong>.
                             </div> 
                             <div v-if="vacationHistory.length == 0" class="o-running-strip o-vacation-history text-center">
                                  {{ $t('no_data_found') }}
                             </div>   
                      </div>                        

                      <div class="modal-footer text-center">
                         
                      </div>
                 
                 </div>
                 <!-- /.modal-content -->
             </div>
             <!-- /.modal-dialog -->
         </div>
    </modal>
         
  </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import { bus } from '../../main';
    import service from '../../services.js';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    export default {
        props: {
            empDetails: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                openAddNoteModal:false,
                getAvailibityList: {},
                running: [],
                upcoming: [],
                validation_err: 0,
                vacationalId: '',
                assignVacation: '',
                vacationList: [],
                vacation_conflict_status:'',
                vacationHistory: [],
                selectedVacationId: '',
                fullName:'',
                userType:'',
                addUnavailibity:{
                  start:'',
                  end:'',
                  day:0
                },
                weeklyVacation: {
                    sun: '',
                    mon: '',
                    tue: '',
                    wed: '',
                    thu: '',
                    fri: '',
                    sat: '',
                },
                empAvail: {
                    startDate: '',
                    endDate: '',
                    startTime: '',
                    endTime: '',
                    label:'',
                },
                empAvailupdate: {
                    startDate: '',
                    endDate: '',
                    startTime: '',
                    endTime: '',
                    label:'',
                },
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        vertical: 'bottom',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;

                            // Adjust hours if necessary for AM/PM logic (optional)
                            // if (hours > 12) hours -= 12;

                            // Return a Moment.js object
                            return moment({ hour: hours, minute: minutes });
                        }
                        }

                        // Default fallback to create a Moment object
                        return moment(inputDate, 'hh:mm A');
                    }
                },
                add_unavalabilty_validation: false,
                add_vacation_validation: false
            };
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID',
                userID: 'userID',
                employeeId: 'employeeId'
            })

        },
        watch: {
            empDetails: function(newData) {
                //console.log('DATA', newData);
                this.vacationalId = this.newData.employable.id;
                this.fullName=this.newData.employable.first_name+" "+this.newData.employable.last_name;

            }
        },
        methods: {

            /**
             * #2046 — render a REFUSED vacation as an error the user can see.
             *
             * ed, 2026-10-04: "Vacations should not overlap, that condition should produce an
             * error on the user side." The server already refused the overlap and saved nothing,
             * but answered 201/200 with status_code "1" — a SUCCESS — and hid the refusal in
             * `result.vacation_process`, carrying a raw, misspelled, unlocalised message
             * ("Vacation confict"). It now answers 409 with status_code "0" and a stable
             * `result.conflict` of 'vacation' or 'booking'.
             *
             * Reachable from BOTH paths on purpose: .then() for an older server (or any HTTP
             * wrapper configured not to throw on 4xx), .catch() for the 409.
             */
            showVacationConflict(body, mode) {
                const r = (body && body.result) || {};
                const key = r.conflict === 'booking' ? 'vacation_overlaps_booking' : 'vacation_overlaps_existing';
                this.$notify({ title: this.$t('error'), message: this.$t(key), type: 'error' });
                if (mode === 'edit') this.$modal.hide("vacation-edit");
                if (r.info) {
                    this.assignVacation = r.info;
                    // The details modal names WHICH row collides — a dispatcher needs that, so it
                    // stays. Only the message changes: a translated string, never the server's raw
                    // `status_message`.
                    if (this.vacation_conflict_status !== undefined) this.vacation_conflict_status = this.$t(key);
                    this.$modal.show("vacation-details");
                }
            },
            /** #2046 — a 409 REJECTS the axios promise, so it lands here and never in .then().
             *  Returns true when it handled the error, so the generic handler can stand down. */
            handleVacationConflict(err, mode) {
                const res = err && err.response;
                if (!res || res.status !== 409) return false;
                this.showVacationConflict(res.data, mode);
                return true;
            },
            saveUnavailability() {
                this.addUnavailability();
                if(this.add_unavalabilty_validation) {
                    this.onUpdateInputField();
                }
            },

            async saveVacation() {
                await this.addVacation();
                if(this.add_vacation_validation) {
                    this.onUpdateInputField();
                }
            },

            setEndDate() {
                // console.log("Check");
                this.empAvail.endDate = this.empAvail.startDate;
                // this.empAvailUpdate.endDate = this.empAvailUpdate.startDate;
            },

            getPickerOption(startDate){
                return {
                    disabledDate(time) {
                        return time.getTime() < +new Date(startDate).setDate(new Date(startDate).getDate() - 1);
                    }
                }
            },
            getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },
            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },
            deleteRow(index, day){
              delete this.getAvailibityList[day][index];
              // this.getAvailibityList[day]= delete rowData[index];
              // console.log(delete rowData[index], rowData, this.getAvailibityList);
              this.addUnavailibity={
                  start:'',
                  end:'',
                  day:0
              }
              // delete rowData[index];
              // console.log(rowData, index);
              this.weeklyVacation.sun = this.getAvailByDay(this.getAvailibityList['1']);
              this.weeklyVacation.mon = this.getAvailByDay(this.getAvailibityList['2']);
              this.weeklyVacation.tue = this.getAvailByDay(this.getAvailibityList['3']);
              this.weeklyVacation.wed = this.getAvailByDay(this.getAvailibityList['4']);
              this.weeklyVacation.thu = this.getAvailByDay(this.getAvailibityList['5']);
              this.weeklyVacation.fri = this.getAvailByDay(this.getAvailibityList['6']);
              this.weeklyVacation.sat = this.getAvailByDay(this.getAvailibityList['7']);
              this.onUpdateInputField();
            },
            addUnavailability(){
              // console.log(this.addUnavailibity, this.getAvailibityList[this.addUnavailibity.day]);
              if(this.addUnavailibity.start!='' && this.addUnavailibity.end!='' && this.addUnavailibity.day!=0){
                

                let tempStart = moment().format('YYYY-MM-DD') + ' ' + moment(this.addUnavailibity.start, 'hh:mm A').format('HH:mm');
                let tempEnd = moment().format('YYYY-MM-DD') + ' '  + moment(this.addUnavailibity.end, 'hh:mm A').format('HH:mm');

                // console.log(tempStart,tempEnd);
                let day1=[];
                let day2=[];
                if(moment(tempStart, 'YYYY-MM-DD HH:mm').isAfter(moment(tempEnd, 'YYYY-MM-DD HH:mm'))){
                    let start1=moment(this.addUnavailibity.start, 'hh:mm A').format('HH:mm');
                    let tempEnd = '11:59 PM'             
                    let end1=moment(tempEnd, 'hh:mm A').format('HH:mm');
                    let tempStart2 = '12:00 AM'
                    let start2=moment(tempStart2, 'hh:mm A').format('HH:mm');
                    let end2=moment(this.addUnavailibity.end, 'hh:mm A').format('HH:mm');
                    let tempDay2 = (parseInt(this.addUnavailibity.day) + 1).toString();
                    day1.push(start1);
                    day1.push(end1);
                    day2.push(start2);
                    day2.push(end2);
                    console.log(tempDay2, typeof tempDay2);
                    this.getAvailibityList[this.addUnavailibity.day][Object.keys(this.getAvailibityList[this.addUnavailibity.day]).length+1]=day1;
                    if(tempDay2 == "8") {
                        tempDay2 = "1"
                    }
                    this.getAvailibityList[tempDay2][Object.keys(this.getAvailibityList[tempDay2]).length+1]=day2;                 
                }else {
                    console.log("Check SingleDay");                    
                    let start=moment(this.addUnavailibity.start, 'hh:mm A').format('HH:mm');                
                    let end=moment(this.addUnavailibity.end, 'hh:mm A').format('HH:mm');
                    day1.push(start);
                    day1.push(end);
                    this.getAvailibityList[this.addUnavailibity.day][Object.keys(this.getAvailibityList[this.addUnavailibity.day]).length+1]=day1;
                    console.log(this.getAvailibityList);
                }
                // console.log(day);
                this.addUnavailibity={
                  start:'',
                  end:'',
                  day:0
                }
                this.weeklyVacation.sun = this.getAvailByDay(this.getAvailibityList['1']);
                this.weeklyVacation.mon = this.getAvailByDay(this.getAvailibityList['2']);
                this.weeklyVacation.tue = this.getAvailByDay(this.getAvailibityList['3']);
                this.weeklyVacation.wed = this.getAvailByDay(this.getAvailibityList['4']);
                this.weeklyVacation.thu = this.getAvailByDay(this.getAvailibityList['5']);
                this.weeklyVacation.fri = this.getAvailByDay(this.getAvailibityList['6']);
                this.weeklyVacation.sat = this.getAvailByDay(this.getAvailibityList['7']);

                this.add_unavalabilty_validation = true;
                // this.onUpdateInputField();
              }else{
                this.add_unavalabilty_validation = false;
                this.$message({
                    type: 'error',
                    message: this.$t('please_fill_all_the_fields_and_try_again')
                });
              }
            },
            gotoVacationLog(){
              this.$store.dispatch('setActionLogType', {
                'logFrom': 'editEmployee',
                'logUser': this.fullName,
              });
              this.$router.push({
                    'path': '/vacationLog/'+ btoa(this.vacationalId)
              });
            },

            deleteVacation(id) {
                this.$confirm(this.$t('permanent_delete_warn'), this.$t('warning'), {
                    confirmButtonText: this.$t('okay'),
                    cancelButtonText: this.$t('cancel'),
                    type: 'warning'
                }).then(() => {
                    service.del('vacation/' + id, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'initiator': this.userID,
                        'affector': this.vacationalId,
                        // 'employeeId': atob(this.$route.params.empId)
                    }).
                    then((res) => {
                        //console.log(res);
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: this.$t('delete_completed')
                        });
                        this.onUpdateInputField();
                        this.getVacation();

                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('delete_canceled')
                    });
                });
            },
            closeVacationHistory() {
                this.$modal.hide("vacation-history");
            },
            addVacationHistory() {
                this.$modal.show("vacation-history");
            },
            async vacationUpdate() {
                //let selectVacation = this.empAvail;
                //console.log(selectVacation);
                let formData = {
                    end: this.empAvailupdate.endDate + " " + dateTimeConvert.convertTo24Hours(this.empAvailupdate.endTime),
                    start: this.empAvailupdate.startDate + " " + dateTimeConvert.convertTo24Hours(this.empAvailupdate.startTime),
                    label: this.empAvailupdate.label,
                };
                if(moment(formData.start, 'YYYY-MM-DD HH:mm:ss') < moment(formData.end, 'YYYY-MM-DD HH:mm:ss')){
                  //console.log('form data', formData);
                   await service.put('vacation/' + this.selectedVacationId, formData, {
                      'Authorization': this.userToken,
                      'cs3-context-role': this.userRole,
                      'cs3-context-clientId': this.userClientID,
                      'initiator': this.userID,
                      'affector': this.vacationalId,
                    //   'employeeId': atob(this.$route.params.empId)
                  }).then((res) => {
                      //console.log(res);
                      if (res.data.result.vacation_process == 1) {
                          this.$notify({
                              title: this.$t('success'),
                              message: this.$t('vacation_update_success'),
                              type: 'success'
                          });
                          this.$modal.hide("vacation-edit");
                          this.getVacation()
                          this.onUpdateInputField();
                          this.empAvailupdate.startDate = "";
                          this.empAvailupdate.endDate = "";
                          this.empAvailupdate.startTime = "";
                          this.empAvailupdate.endTime = "";
                          this.empAvailupdate.label = "";
                      } else {
                          // #2046 — was: open the details modal carrying the server's raw `status_message`
                          // ("Vacation confict"), with no error notification and a SUCCESS status behind it.
                          this.showVacationConflict(res.data, 'edit');
                      }

                  }).catch((err) => {
                      // #2046 — an overlapping vacation now arrives as a 409, i.e. HERE. Handling it only
                      // in .then() would leave the user with no message at all.
                      if (this.handleVacationConflict(err, 'edit')) return;
                      console.log(err);
                  });
                }else{
                  this.$notify({
                      title: this.$t('error'),
                      message: this.$t('vacation_end_after_start'),
                      type: 'error'
                  });
                }
                //console.log(fromData);

            },
            async editVacation(id) {
                // opens edit vacation modal
                this.selectedVacationId = id;
                this.$modal.show("vacation-edit");
                await service.get('vacation/' + id, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    // 'employeeId': atob(this.$route.params.empId)
                }).then((res) => {
                    //console.log(res);
                    $('.custom_date input').attr('readonly','readonly');
                    let vacDetails = res.data.result;
                    this.empAvailupdate.startDate = vacDetails.start.split(" ")[0];
                    this.empAvailupdate.endDate = vacDetails.end.split(" ")[0];
                    this.empAvailupdate.startTime = vacDetails.start.split(" ")[1];
                    this.empAvailupdate.endTime = vacDetails.end.split(" ")[1];
                    this.empAvailupdate.label = vacDetails.label;
                }).catch((err) => {
                    console.log(err);
                });
                // this.onUpdateInputField();
            },
            closeVacationEdit() {
                this.$modal.hide("vacation-edit");
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            getDate(str) {

                //console.log(str);
                if (typeof str != "undefined") {
                    return dateTimeConvert.localDate(str);
                    //var date = str.split(" ");
                    //return date[0];
                }
            },
            getDateFormat(dateTime) {
                //var date = dateTimeConvert.extractDateOnly(dateTime);
                //return dateTimeConvert.extractDateOnly(dateTime);
                return dateTimeConvert.localDate(dateTime);
            },
            closeVacationDetails() {
                this.$modal.hide("vacation-details");
            },
            addVacation() {
                this.$validator.validateAll().then(async (result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        //let selectVacation = this.empAvail;
                        //console.log(selectVacation);
                        let formData = {
                            vacationable_id: this.vacationalId,
                            end: this.empAvail.endDate + " " + dateTimeConvert.convertTo24Hours(this.empAvail.endTime),
                            start: this.empAvail.startDate + " " + dateTimeConvert.convertTo24Hours(this.empAvail.startTime),
                            label: this.empAvail.label,
                        };
                        if(moment(formData.start, 'YYYY-MM-DD HH:mm:ss') < moment(formData.end, 'YYYY-MM-DD HH:mm:ss')){
                          //console.log('form data', formData);
                          await service.post('vacation', formData, {
                              'Authorization': this.userToken,
                              'cs3-context-role': this.userRole,
                              'cs3-context-clientId': this.userClientID,
                              'initiator': this.userID,
                              'affector': this.vacationalId,
                            //   'employeeId': atob(this.$route.params.empId)
                          }).then((res) => {
                              //console.log(res);
                              if (res.data.result.vacation_process == 1) {
                                  this.$notify({
                                      title: this.$t('success'),
                                      message: this.$t('vacation_update_success'),
                                      type: 'success'
                                  });
                                //   this.onUpdateInputField();
                                  this.empAvail.startDate = "";
                                  this.empAvail.endDate = "";
                                  this.empAvail.startTime = "";
                                  this.empAvail.endTime = "";
                                  this.empAvail.label = "";
                                  this.getVacation();
                                  this.add_vacation_validation = true;
                              } else {
                                  // #2046 — was: open the details modal carrying the server's raw `status_message`
                                  // ("Vacation confict"), with no error notification and a SUCCESS status behind it.
                                  this.showVacationConflict(res.data, 'add');
                              }


                          }).catch((err) => {
                              this.add_vacation_validation = false;
                              // #2046 — an overlapping vacation now arrives as a 409, i.e. HERE. Handling it only
                              // in .then() would leave the user with no message at all.
                              if (this.handleVacationConflict(err, 'add')) return;
                              console.log(err);
                          });
                          //console.log(fromData);
                        }else{
                          this.add_vacation_validation = false;
                          this.$notify({
                              title: this.$t('error'),
                              message: this.$t('vacation_end_after_start'),
                              type: 'error'
                          });
                        }
                    } else {
                        this.add_vacation_validation = false;
                        console.log("error");
                        this.validation_err = 1;
                    }
                });
            },
            getVacation() {
                let formData = {
                    vacationable_id: this.vacationalId,
                };
                service.post('vacation/getEmployeevacations', formData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    // 'employeeId': atob(this.$route.params.empId)
                }).then((res) => {
                    this.vacationList = res.data.result;
                    //console.log(this.vacationList);
                    this.running = this.vacationList.running;
                    this.upcoming = this.vacationList.upcoming;

                }).catch((err) => {
                    console.log(err);
                });
            },
            getVacationHistory() {
                let formData = {
                    vacationable_id: this.vacationalId,
                };
                service.post('vacation/getEmployeeVacationHistory', formData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    // 'employeeId': atob(this.$route.params.empId)
                }).then((res) => {
                    //console.log(res);
                    this.vacationHistory = res.data.result;
                    //console.log(this.vacationHistory);

                }).catch((err) => {
                    console.log(err);
                });
            },
            onUpdateInputField() {
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                bus.$emit('onUpdateVacation', this.weeklyVacation);
                //console.log(this.weeklyVacation)
            },
            getAvailByDay(day) {
                let daycount = "";
                /* day.forEach(function(dayslot) {
                     
                     daycount = daycount + "," + dayslot[0] + "-" + dayslot[1];
                 });
                 console.log("daycount", daycount);
                 return daycount;*/
                for (let i = 0; i < Object.keys(day).length; i++) {

                    if (daycount != "") {
                        daycount = daycount + "," + day[i + 1][0] + "-" + day[i + 1][1];
                    } else {
                        daycount = day[i + 1][0] + "-" + day[i + 1][1];
                    }

                }
                return daycount;
            }

        },
         mounted() {
            $('.custom_date input').attr('readonly','readonly');
            // Employee Box Height Align
            //var employeeBoxHeight = $('.js-employee-boxHeight').outerHeight();
            //alert(employeeBoxHeight);
            //$('.js-employee-boxAppend').css('height', employeeBoxHeight);
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();

                // Check if the input is empty and set the current time in the picker
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        },
        created() {
            this.userType=this.$cookies.get('csLogin');
            this.vacationalId = this.empDetails.employable.id;
            this.fullName=this.empDetails.employable.first_name+" "+this.empDetails.employable.last_name;
            //this.vacationList = this.empDetails.employable.vacations;
            //console.log(this.empDetails);
            this.getVacation();
            this.getVacationHistory();
            this.getAvailList = this.empDetails;

            if (this.empDetails.available_times == null || this.empDetails.available_times == '') {
                this.getAvailibityList = {
                    1: {},
                    2: {},
                    3: {},
                    4: {},
                    5: {},
                    6: {},
                    7: {}
                };
            } else {
                this.getAvailibityList = JSON.parse(this.empDetails.available_times);
            }

            bus.$on('updateNoteCancel', () => {
                if (this.empDetails.available_times == null) {
                this.getAvailibityList = {
                    1: {},
                    2: {},
                    3: {},
                    4: {},
                    5: {},
                    6: {},
                    7: {}
                };
            } else {
                this.getAvailibityList = JSON.parse(this.empDetails.available_times);
            }
            });
            // this.onUpdateInputField();
            //console.log("DATA", this.getAvailibityList['2']['1']);

        }
    }

</script>
<style scoped>
.mr-10 {
    margin-right: 10px;
}
.c-user-vacation-mam-height {
  min-height: 360px
}
.o-vacation-label{
  background-color: #b6b6b63d !important;
  font-size: 13px !important;
}
.c-skillset--avail li {
    float: left;
    width: 33%;
    min-height: 100px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
}
.unavaliablility-delete-btn{
    font-size: 20px;
    margin-left: 5px;
    color:#ff5656;
}
</style>
